/* ============================================================
   Casa del Estilista — Carrito Variante A
   assets/ced-cart.js
   - Vaciar carrito  (/cart/clear.js)
   - Guardar para después + Mover al carrito  (localStorage + /cart/add|change.js)
   - Toggle de cotización PDF
   La cantidad y el "Eliminar" los maneja Dawn (cart.js / quantity-input /
   cart-remove-button). Aquí solo lo aditivo.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'ced_saved';
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function getSaved() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function setSaved(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    });
  }

  function renderSaved() {
    var el = document.getElementById('ced-saved');
    if (!el) return;
    var list = getSaved();
    if (!list.length) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    el.innerHTML =
      '<div class="ced-saved__title">Guardado para después</div>' +
      list.map(function (i) {
        return '' +
          '<div class="ced-saved__row">' +
            '<div class="ced-saved__media">' + (i.img ? '<img src="' + esc(i.img) + '" alt="" width="54" height="64">' : '') + '</div>' +
            '<div class="ced-saved__info">' +
              '<a href="' + esc(i.url) + '" class="ced-saved__name">' + esc(i.title) + '</a>' +
              '<div class="ced-saved__price">' + esc(i.price) + '</div>' +
            '</div>' +
            '<button type="button" class="ced-btn ced-btn--mini" data-ced-move data-vid="' + esc(i.vid) + '">Mover al carrito</button>' +
            '<button type="button" class="ced-iconbtn ced-iconbtn--bare" data-ced-remove-saved data-vid="' + esc(i.vid) + '" title="Quitar" aria-label="Quitar">' + CLOSE_SVG + '</button>' +
          '</div>';
      }).join('');
  }

  document.addEventListener('click', function (e) {
    // -------- Vaciar carrito --------
    var clear = e.target.closest('[data-ced-clear]');
    if (clear) {
      e.preventDefault();
      if (clear.dataset.busy) return;
      clear.dataset.busy = '1';
      postJSON('/cart/clear.js').then(function () { window.location.reload(); });
      return;
    }

    // -------- Toggle cotización --------
    var qt = e.target.closest('[data-ced-quote-toggle]');
    if (qt) {
      var panel = qt.parentNode.querySelector('.ced-quote__panel');
      if (panel) panel.hidden = !panel.hidden;
      return;
    }

    // -------- Guardar para después --------
    var save = e.target.closest('[data-ced-save]');
    if (save) {
      e.preventDefault();
      if (save.dataset.busy) return;
      save.dataset.busy = '1';
      var d = save.dataset;
      var list = getSaved();
      if (!list.some(function (x) { return String(x.vid) === String(d.vid); })) {
        list.push({ vid: d.vid, key: d.key, title: d.title, img: d.img, url: d.url, price: d.price });
        setSaved(list);
      }
      // Quitar la línea del carrito (cantidad 0) y recargar
      postJSON('/cart/change.js', { id: d.key, quantity: 0 }).then(function () {
        window.location.reload();
      });
      return;
    }

    // -------- Mover de "guardado" al carrito --------
    var mv = e.target.closest('[data-ced-move]');
    if (mv) {
      e.preventDefault();
      if (mv.dataset.busy) return;
      mv.dataset.busy = '1';
      var vid = mv.dataset.vid;
      postJSON('/cart/add.js', { id: vid, quantity: 1 }).then(function (r) {
        if (r.ok) {
          setSaved(getSaved().filter(function (x) { return String(x.vid) !== String(vid); }));
          window.location.reload();
        } else {
          mv.dataset.busy = '';
        }
      });
      return;
    }

    // -------- Quitar de "guardado" --------
    var rm = e.target.closest('[data-ced-remove-saved]');
    if (rm) {
      e.preventDefault();
      setSaved(getSaved().filter(function (x) { return String(x.vid) !== String(rm.dataset.vid); }));
      renderSaved();
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderSaved);
  } else {
    renderSaved();
  }
})();

/* ── Barra de envío gratis — animación progresiva ────────────────────────────
   La barra se renderiza con width:0 y data-ced-fill="X".
   El doble RAF garantiza que el browser ha pintado el estado inicial (0%)
   antes de aplicar el ancho real, disparando la transición CSS (.45s).
   El MutationObserver reactiva la animación tras cada re-render de Dawn.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  function animarBarra(root) {
    var fill = (root || document).querySelector('.ced-ship__fill[data-ced-fill]');
    if (!fill) return;
    var pct = parseFloat(fill.getAttribute('data-ced-fill')) || 0;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.width = pct + '%';
      });
    });
  }

  /* Animación inicial al cargar la página */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { animarBarra(); });
  } else {
    animarBarra();
  }

  /* Re-animación tras cada actualización de cantidad (Dawn reemplaza js-contents) */
  var cartEl = document.getElementById('main-cart-items');
  if (cartEl) {
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { animarBarra(cartEl); }, 40);
    }).observe(cartEl, { childList: true, subtree: true });
  }
})();

